import React, { FunctionComponent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import i18next from 'i18next';

import useTypedSelector from 'hooks/useTypedSelector';
import { IServicesFormData } from 'views/ServicesView/components/ServicesForm/types';
import { onGetOne, onSave } from 'redux/actions/services.actions';
import { servicesFormSelector, servicesFilesSelector } from 'redux/selectors/services.selector';

import LayoutContainer from 'containers/LayoutContainer';
import ServicesForm from 'views/ServicesView/components/ServicesForm';
import Loading from 'components/commons/Loading';

import 'views/ServicesView/components/ServicesForm/i18n';

const ServicesFormContainer: FunctionComponent = () => {
  const dispatch = useDispatch();
  const { id = '' } = useParams<{ id?: string }>();
  const initialValues = useTypedSelector(servicesFormSelector);
  const files = useTypedSelector(servicesFilesSelector);
  const { loading } = useTypedSelector((state) => state.services);
  const isEditing = !!id;

  useEffect(() => {
    if (id) dispatch(onGetOne(id));
    return () => {
      dispatch(onGetOne(''));
    };
  }, [dispatch, id]);

  const onSubmit = (formData: IServicesFormData) => dispatch(onSave(formData, id));

  return (
    <LayoutContainer auth title={i18next.t<string>('SERVICES_FORM:TITLE')}>
      <ServicesForm
        initialValues={initialValues}
        isEditing={isEditing}
        files={files}
        onSubmit={onSubmit}
      />
      {loading && <Loading isModalMode message={i18next.t('SERVICES_FORM:LOADING')} />}
    </LayoutContainer>
  );
};

export default ServicesFormContainer;
